export default __webpack_public_path__ + "static/media/home-page-seamless-process.b7b58dd9.png";